import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ApiUrlService {
  private readonly baseUrl = environment.urlApiEndPointV3.replace(/\/$/, '');
  private readonly clienteChatBasePath = '/api/v1/cliente-farmacia/chat';
  private readonly chatSocketPath = '/ws/chat';

  get apiBase(): string {
    return this.baseUrl;
  }

  build(path: string): string {
    const normalizedPath = path.startsWith('/') ? path : `/${path}`;
    return `${this.baseUrl}${normalizedPath}`;
  }

  buildWebSocket(path: string, queryParams: Record<string, string | number | boolean | null | undefined> = {}): string {
    const normalizedPath = path.startsWith('/') ? path : `/${path}`;
    const wsBase = this.baseUrl.replace(/^http:/i, 'ws:').replace(/^https:/i, 'wss:');
    const url = new URL(`${wsBase}${normalizedPath}`);

    Object.entries(queryParams).forEach(([key, value]) => {
      if (value === null || value === undefined) return;
      url.searchParams.set(key, String(value));
    });

    return url.toString();
  }

  get loginUserApiEnd(): string {
    return this.build('/users/user-info-recover');
  }

  get tokenUserApiEnd(): string {
    return this.build('/token');
  }

  get statusUserApiEnd(): string {
    return this.build('/status');
  }

  get me(): string {
    return this.build('/api/v1/me');
  }

  get clienteChatBase(): string {
    return this.build(this.clienteChatBasePath);
  }

  get clienteChatUnreadCount(): string {
    return this.build(`${this.clienteChatBasePath}/unread-count`);
  }

  get clienteChatMessages(): string {
    return this.build(`${this.clienteChatBasePath}/messages`);
  }

  get clienteChatMessagesWithAttachments(): string {
    return this.build(`${this.clienteChatBasePath}/messages/with-attachments`);
  }

  get clienteChatRead(): string {
    return this.build(`${this.clienteChatBasePath}/read`);
  }

  clienteChatAttachmentDownloadUrl(idAttachment: number | string): string {
    return this.build(`${this.clienteChatBasePath}/attachments/${idAttachment}/download-url`);
  }

  clienteChatAttachmentContent(idAttachment: number | string): string {
    return this.build(`${this.clienteChatBasePath}/attachments/${idAttachment}/content`);
  }

  chatWebSocketUrl(accessToken: string): string {
    return this.buildWebSocket(this.chatSocketPath, { token: accessToken });
  }
}
